import { Party } from "./../model/party.model";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Branch, form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { take } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { Personnel, PersonnelBranch, PersonnelDocuments, PersonnelRoles, PersonnelRolesEnum } from "../model/personnel.model";
import { MaxCodeViewModel } from "../model/customer.model";

@Component({
  selector: "ngx-personnel",
  templateUrl: "./personnel-form.component.html",
  styleUrls: ["./personnel-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonnelFormComponent extends BaseFormComponent<Personnel> {
  haserror: boolean = false;
  isOk4Load: boolean = false;
  erroremessage: string;
  roles: number[] = [];
  documents: number[] = [];
  rolesIsLodes: boolean = false;
  documentsIsLodes: boolean = false;
  isSelectedDriverRoles: boolean = false;
  isSelectedWaiterRoles: boolean = false;
  selectedCashier: boolean = false;
  hasCredit: boolean = false;
  setPattern: boolean = false;
  DefaultValues: Dictionary = [];
  isAccessToAllBranches = true;
  UserList: any;
  Branches: form_control[];
  deactivateSave: boolean = false;
  showBranch: boolean = false;
  disabledBailPrice: boolean = false;
  public PersonnelRolesEnum: typeof PersonnelRolesEnum = PersonnelRolesEnum;

  constructor(private lookupservice: LookupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }

  async ngOnInit() {
    this.apiName = "Personnel";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Parties.Personnel.Staff");
    super.ngOnInit();
    this.DefaultValues["PersonnelId"] = 0;
  }

  ngAfterViewInit(): void {
    this.FillData();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.roles = undefined;
    this.documents = undefined;
    this.DefaultValues = undefined;
    this.UserList = undefined;
    this.Branches = undefined;
  }

  async FillData() {
    this.httpCommonService
      .getList("Personnel/ReadUsers/null")
      .pipe(take(1))
      .subscribe(
        async (data: any) => {
          if (data) this.UserList = data.filter((x) => x.Title !== this.translate("ClientApp.FrontOffice.Parties.Personnel.SepidzUser"));
        },
        (error) => this.getFailedHelper(error)
      );
    const currentInformation = this.accountService.authService.currentInformation();
    if (currentInformation.BranchingLightEnabled || currentInformation.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch/Personnel")
        .pipe(take(1))
        .subscribe(
          (hbc: CheckBrachAccessModel) => {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Parties.Personnel.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.Parties.Personnel.Attention")
              );
              this.deactivateSave = true;
              return;
            } else if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Parties.Personnel.HasCallCenterCommunication"),
                this.translate("ClientApp.FrontOffice.Parties.Personnel.Attention")
              );
              this.deactivateSave = true;
              return;
            }
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }

  setdefault() {
    if (!this.model.Branches) this.model.Branches = [];
    if (!this.model.Documents) this.model.Documents = [];
    if (!this.model.Roles) this.model.Roles = [];

    //اگر در مد ایجاد بودیم
    if (this.model && !(this.model.Id > 0)) this.model.IsActive = true;

    this.model.Roles.forEach((x) => {
      if (!this.roles.some((r) => r === x.RolesId)) this.roles.push(x.RolesId);
    });
    this.model.Documents.forEach((x) => {
      if (!this.documents.some((d) => d === x.DocumentsId)) this.documents.push(x.DocumentsId);
    });
    this.rolesIsLodes = true;
    this.documentsIsLodes = true;

    if (!this.accountService.authService.currentBranch) setTimeout(() => this.populateBranch(), 300);
    else this.populateBranch();

    //اگر در مد ویرایش بودیم
    if (!this.isNewRow && this.model.PartyId) {
      if (this.formGroup?.controls["PartyId"]) this.formGroup.controls["PartyId"].disable();
      if (this.formGroup?.controls["Number"]) this.formGroup.controls["Number"].disable();
      if (this.model.Roles.length > 0 && this.model.Roles.find((x) => x.RolesTitle?.includes(PersonnelRolesEnum.Driver))) {
        this.isSelectedDriverRoles = true;
        this.hasCredit = this.model.HasCredit;
      }
      if (
        this.model.Roles.length > 0 &&
        (this.model.Roles.find((x) => x.RolesTitle?.includes(PersonnelRolesEnum.Waiter)) ||
          this.model.Roles.find((x) => x.RolesTitle?.includes(this.translate("ClientApp.FrontOffice.Parties.Personnel.Garsoon"))))
      ) {
        this.isSelectedWaiterRoles = true;
      }
      if (this.model.BailTypeId) this.formGroup.controls["BailPrice"].enable();
    }
    if (this.model.UserId) {
      this.httpCommonService
        .getList(`Personnel/ReadUsers/${this.model.UserId}`)
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            if (data) {
              const findItem = data.find((f) => f.Id === this.model.UserId);
              this.UserList.push(findItem);
              const CopyList = this.UserList.sort((a, b) => a.Id - b.Id);
              this.UserList = null;
              this.UserList = Object.assign([], CopyList);
              this.setValue("UserId", this.model.UserId);
            }
          },
          (error) => this.getFailedHelper(error)
        );
    }
    if (this.model?.RolesTitle?.includes(this.translate("ClientApp.FrontOffice.Parties.Personnel.Cashier"))) this.selectedCashier = true;
    setTimeout(() => {
      document.getElementById("FirstName")?.focus();
      const input: HTMLInputElement = document.getElementById("FirstName") as HTMLInputElement;
      if (input) input.focus();
    }, 2000);
    this.cd.markForCheck();
  }

  addControl() {
    this.isOk4Load = false;
    if (this.formGroup) {
      this.setValue("RolesId", this.roles);
      this.formGroup.controls["RolesId"].setValidators([Validators.required]);
      this.setValue("Documents", this.documents);
      this.setValue("UserId", this.model.UserId);
      this.setValue("UserIdEditMode", this.model.UserId);
      this.setValue("PartyId", this.model.PartyId);
      this.setValue("DisplayName", this.model.DisplayName);
      this.setValue("PartyIdEditMode", this.model.PartyId);
      this.setValue("CreditControlTypeId", this.model.CreditControlTypeId);
      this.setValue("CreditLimit", this.model.CreditLimit);
      this.setValue("DetailLedgerId", this.model.DetailLedgerId);
      this.setValue("SubLedgerId", this.model.SubLedgerId);
      this.isOk4Load = (this.model && this.model.PartyId && !this.isNewRow) || this.isNewRow;
    } else this.cd.markForCheck();
    if (this.model) this.checkByBailTypeId();
    this.cd.markForCheck();
  }

  ChangeRoles(event: Lookup[]) {
    let isFoundDriverRoles = false;
    let isFoundCashier = false;
    this.isSelectedWaiterRoles = false;
    if ((this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Personnel.SelectingLeastOneRoleRequired")))
      this.erroremessage = undefined;
    event.forEach((x) => {
      if (x.Title === this.translate("ClientApp.FrontOffice.Parties.Personnel.Courier")) {
        isFoundDriverRoles = true;
        this.isSelectedDriverRoles = true;
        // if (this.model) {
        //   this.lookupservice
        //     .getLookupbyCode("SALE", "DriverStatus")
        //     .pipe(takeUntil(this.ngUnsubscribe))
        //     .subscribe((statusLookup) => {
        //       this.model.CurrentBranch.DriverStatusId = statusLookup.Id;
        //       this.formGroup.controls["DriverStatusId"].setValue(statusLookup.Id);
        //     });
        //   this.lookupservice
        //     .getLookupbyCode("SALE", "DriverAttendanceStatus", DriverAttendanceStatus.Present)
        //     .pipe(takeUntil(this.ngUnsubscribe))
        //     .subscribe((statusLookup) => {
        //       this.model.CurrentBranch.DriverAttendanceStatusId = statusLookup.Id;
        //       this.formGroup.controls["DriverAttendanceStatusId"].setValue(statusLookup.Id);
        //     });
        // }
      } else if (x.Title === this.translate("ClientApp.FrontOffice.Parties.Personnel.Cashier")) {
        isFoundCashier = true;
        this.selectedCashier = true;
      } else if (x.Title === PersonnelRolesEnum.Waiter || x.Title === this.translate("ClientApp.FrontOffice.Parties.Personnel.Garsoon")) {
        this.isSelectedWaiterRoles = true;
      }
    });
    if (!isFoundDriverRoles) this.isSelectedDriverRoles = false;

    if (!isFoundCashier) this.selectedCashier = false;

    this.isValid();
  }

  setpatternKey() {
    this.orignalColumns.forEach((x) => {
      if (x.name === "MobileNumber") x.patternKey = "^[0-0][9-9]\\d{9}";
      if (x.name === "PhoneNumber") x.patternKey = "^[1-9]\\d{3,7}";
    });
  }

  populateBranch() {
    this.httpCommonService
      .getList("Branch")
      .pipe(take(1))
      .subscribe(async (data: Branch[]) => {
        let BranchList: Branch[] = data;
        if (!this.model) this.model = <Personnel>{};
        if (!this.model.Branches) this.model.Branches = [];
        BranchList?.forEach((br: Branch) => {
          const listBranch = this.model.Branches.find((x) => x.BranchId === br.Id);
          if (!listBranch) {
            let entity = <PersonnelBranch>{};
            entity.BranchId = br.Id;
            entity.BranchTitle = br.Title;
            entity.IsActive = true;
            entity.State = RowState.New;

            //اگر در مد ایجاد بودیم
            if (!this.model || !(this.model.Id > 0)) entity.Selected = true;
            else entity.Selected = false;

            this.model.Branches.push(entity);
            this.cd.markForCheck();
          } else listBranch.Selected = true;
        });

        this.showBranch = true;
      });
  }

  PartyAccountChange(event) {
    if (!event) {
      this.formGroup.controls["FirstName"].enable();
      this.formGroup.controls["LastName"].enable();
      this.formGroup.controls["Number"].enable();
      this.formGroup.controls["PhoneNumber"].enable();
    }
    if (event && event.Number && event.LastName) {
      if (!event.FirstName) this.formGroup.controls["FirstName"].enable();
      this.model.Number = event.Number;
      this.formGroup.controls["Number"].setValue(event.Number);
      this.model.FirstName = event.FirstName;
      this.formGroup.controls["FirstName"].setValue(event.FirstName);
      this.model.LastName = event.LastName;
      this.formGroup.controls["LastName"].setValue(event.LastName);
      this.model.Description = event.Description;
      this.formGroup.controls["Description"].setValue(event.Description);
      this.model.MobileNumber = event.MobileNumber;
      this.formGroup.controls["MobileNumber"].setValue(event.MobileNumber);
      this.model.PhoneNumber = event.PhoneNumber;
      this.formGroup.controls["PhoneNumber"].setValue(event.PhoneNumber);
      this.model.Address = event.Address;
      this.formGroup.controls["Address"].setValue(event.Address);
      this.model.DetailLedgerId = event.Party.DetailLedgerId;
      this.setValue("DetailLedgerId", this.model.DetailLedgerId);
      if (this.formGroup.controls["FirstName"].value) this.formGroup.controls["FirstName"].disable();
      this.formGroup.controls["Number"].disable();
      this.formGroup.controls["LastName"].disable();
    }
    setTimeout(() => {
      const input: HTMLInputElement = document.getElementById("Description") as HTMLInputElement;
      input.focus();
    }, 100);
    this.cd.markForCheck();
  }

  valueChange() {
    if (this.formGroup && this.formGroup.controls["MobileNumber"] && this.formGroup.controls["PhoneNumber"] && !this.setPattern) {
      this.formGroup.controls["MobileNumber"].clearValidators();
      this.formGroup.controls["MobileNumber"].setErrors(null);
      this.formGroup.controls["MobileNumber"].setValidators([Validators.required, Validators.pattern("^[0-0][9-9]\\d{9}")]);
      this.formGroup.controls["PhoneNumber"].clearValidators();
      this.formGroup.controls["PhoneNumber"].setErrors(null);
      this.formGroup.controls["PhoneNumber"].setValidators([Validators.pattern("^[1-9]\\d{3,7}")]);
      this.setPattern = true;
    }
  }

  openImageUpload(fileToUpload: any): boolean {
    if (fileToUpload.target.files && fileToUpload.target.files[0]) {
      const max_size = 300000;
      const max_height = 512;
      const max_width = 512;

      if (fileToUpload.target.files[0].size > max_size) {
        let error =
          this.translate("ClientApp.FrontOffice.Parties.Personnel.UploadedImageSizeLessThan") +
          max_size / 1000 +
          this.translate("ClientApp.FrontOffice.Parties.Personnel.BeKb");
        this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Parties.Personnel.Error"));
        return false;
      }
      const formData = new FormData();
      formData.append("photo", fileToUpload.target.files[0]);
      formData.append("PersonnelId", this.model.Id.toString());
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let image = new Image();
        image.src = e.target.result;
        image.onload = (rs: any): any => {
          const img_height = rs.currentTarget["height"];
          const img_width = rs.currentTarget["width"];
          if (img_height > max_height || img_width > max_width) {
            let error = this.translate("ClientApp.FrontOffice.Parties.Personnel.ImageSizeNotAllowed");
            this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Parties.Personnel.Error"));
            return false;
          } else {
            this.httpCommonService
              .upload("Personnel/UploadPhoto", formData)
              .pipe(take(1))
              .subscribe({
                next: (response: any) => {
                  this.model.Image = response.imagePath;
                  this.formGroup.controls["Image"].setValue(response.imagePath);
                  this.sts.showDialog(
                    this.translate("ClientApp.FrontOffice.Parties.Personnel.ImageUploadedSuccessfullySaveChanges"),
                    this.translate("ClientApp.FrontOffice.Parties.Personnel.Message")
                  );
                },
                error: (err) =>
                  this.sts.showDialog(
                    this.translate("ClientApp.FrontOffice.Parties.Personnel.ErrorLoadingImage"),
                    this.translate("ClientApp.FrontOffice.Parties.Personnel.Error")
                  ),
              });
          }
        };
      };
      reader.readAsDataURL(fileToUpload.target.files[0]);
    }
  }

  beforupdate() {
    this.model.Id = this.formGroup.controls["Id"].value;
    this.roles = this.formGroup.controls["RolesId"].value;
    this.documents = this.formGroup.controls["Documents"].value;

    this.model.Branches = this.model.Branches.filter((x) => x.Selected);

    if (this.model.Branches && this.model.Branches.length <= 0) this.model.Branches = null;
    else {
      this.model.Branches.forEach((x) => {
        x.VehicleId = x.VehicleId || 0;
        if (x.BranchId === this.accountService.authService.currentBranchId && x.State != RowState.Modify && !this.isMultiBranch) {
          x.IsActive = this.formGroup.controls["IsActive"].value;
          x.State = RowState.Modify;
        }
      });
    }

    this.model.Documents.forEach((x) => {
      if (!this.documents.some((d) => d === x.DocumentsId)) x.State = RowState.Delete;
    });

    this.documents.forEach((x) => {
      if (!this.model.Documents.some((d) => d.DocumentsId === x)) {
        var doc: PersonnelDocuments = <PersonnelDocuments>{};
        doc.DocumentsId = x;
        doc.PersonnelId = this.model.Id;
        doc.State = RowState.New;
        this.model.Documents.push(doc);
      }
    });
    this.setValue("Documents", this.model.Documents);

    this.model.Roles.forEach((x) => {
      if (!this.roles.some((r) => r === x.RolesId)) x.State = RowState.Delete;
    });
    this.roles.forEach((x) => {
      if (!this.model.Roles.some((r) => r.RolesId === x)) {
        var role: PersonnelRoles = <PersonnelRoles>{};
        role.RolesId = x;
        role.PersonnelId = this.model.Id;
        role.State = RowState.New;
        this.model.Roles.push(role);
      }
    });
    this.setValue("Roles", this.model.Roles);

    if (this.formGroup.controls["PartyId"].value === null) this.formGroup.controls["PartyId"].setValue(0);

    if (this.formGroup.controls["PhoneNumber"].value === null) this.formGroup.controls["PhoneNumber"].setValue(undefined);
  }

  isValid() {
    this.erroremessage = undefined;
    this.haserror = false;
    if (!this.formGroup.controls["RolesId"].value || this.formGroup.controls["RolesId"].value <= 0) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Personnel.SelectingLeastOneRoleRequired");
    } else if (this.selectedCashier && !this.formGroup.controls["UserId"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Personnel.ChooseCashierRoleMandatoryUserAccount");
    } else if (this.hasCredit) {
      if (!this.formGroup.controls["CreditControlTypeId"].value) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Personnel.ChoosingCreditControlMethodMandatoryCreditPeakMode");
      } else if (!this.formGroup.controls["CreditLimit"].value) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Personnel.EnteringCreditLimitRequiredCreditControlSelectionMode");
      }
    }
    if (!this.haserror) this.checkByBailTypeId();
    let activeAllDriverForBranch = this.model.Branches.some((x) => x.IsActive === false);
    let isActiveCount = this.model.Branches.filter((x) => x.IsActive);
    if (isActiveCount.length > 1 && activeAllDriverForBranch && this.model.Roles.find((x) => x.RolesTitle?.includes(PersonnelRolesEnum.Driver))) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Parties.Personnel.OnlyCourierBranchActive"),
        this.translate("ClientApp.FrontOffice.Parties.Personnel.ErrorSavingChanges")
      );
      this.haserror = true;
      this.isSaved = false;
      return;
    }
    return !this.haserror;
  }

  protected saveFailedHelper(error: any) {
    this.submitted = false;
    this.selectorService.submitted$.next(this.submitted);
    this.isClosing = false;
    this.isSaving = false;
    const message: any = Utilities.getHttpResponseMessage(error);
    this.sts.showToast(
      "danger",
      this.translate("ClientApp.FrontOffice.Parties.Personnel.SaveError"),
      `${this.translate("ClientApp.FrontOffice.Parties.Personnel.ErrorSavingChanges")}: ${message}`
    );
    this.sts.showDialog(
      `${this.translate("ClientApp.FrontOffice.Parties.Personnel.ErrorSavingChanges")}: ${message}`,
      this.translate("ClientApp.FrontOffice.Parties.Personnel.ErrorMessage")
    );
    const regex = /کد جدید (\d+) جایگذاری/;
    const found = message.match(regex);
    if (found) {
      const value = found[1];
      this.model.Number = +value;
      this.setValue("Number", +value);
    }
    if (this.changesFailedCallback) this.changesFailedCallback();
    this.saveHasError();
  }

  setMaxCode() {
    this.httpCommonService
      .get(this.apiName + "/GetPersonnelMaxCode")
      .pipe(take(1))
      .subscribe((data: MaxCodeViewModel) => {
        if (data.HaspreFix) {
          this.formGroup.controls["Number"].disable();
          this.columns.find((f) => f.name === "Number").disabled = true;
        }
        if (!this.model) this.model = <Personnel>{};
        if (data) this.model["Number"] = data.MaxCode;

        this.setdefault();
        this.setFormGroup(this.model);
      });
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    const license = this.accountService.authService.currentInformation();
    const isMultiBranch = license.BranchingAdvancedEnabled || license.BranchingLightEnabled || license.RestaurantCallCenter;
    this.orignalColumns.forEach((x) => {
      if (x.name === "SubLedgerId" || x.name === "DetailLedgerId")
        x.formVisible =
          license.AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
          license.AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
          license.AccountingKind === SoftWareLicenseKind.AccountingWeb;
      if (x.name === "GoodsId")
        x.formVisible =
          license.InventoryKind === SoftWareLicenseKind.InventoryWeb ||
          license.InventoryKind === SoftWareLicenseKind.InventoryAdvancedWeb ||
          license.InventoryKind === SoftWareLicenseKind.InventoryToAdvancedWeb;
      if (isMultiBranch) {
        if (x.name === "IsActive") {
          x.formVisible = false;
        }
      }
    });
    this.orignalColumns.forEach((x) => {
      if (x.name === "Number") x.disabled = !this.isNewRow;
    });
    this.Branches = this.getDetailControlModels("Branches");
    this.columns.find((f) => f.name == "PhoneNumber").isNumberOnly = true;
    this.columns.find((f) => f.name == "MobileNumber").isNumberOnly = true;
    this.columns.find((f) => f.name == "FirstName").max = 40;
  }
  CreditCourierChange(event) {
    this.hasCredit = event;
    this.isValid();
  }
  CreditControlTypeChange($event) {
    this.isValid();
  }
  ChangeBailPrice(event: any) {
    this.model.BailPriceTypeCode = event.Code;
    this.checkByBailTypeId();
  }

  private checkByBailTypeId() {
    if (this.model.BailPriceTypeCode) {
      this.formGroup.controls["BailPrice"].enable();
      this.disabledBailPrice = false;
    } else {
      this.formGroup.controls["BailPrice"].disable();
      this.disabledBailPrice = true;
    }
  }
}
